import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { useDispatch } from "react-redux";
import { CommonInformationDialogReduerAction } from "../../../Store/dialog/CommonInformationDialogReduer";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";
import { Visibility } from "@mui/icons-material";

const SanctionRemarks = ({ SanctionRemarksInfo }) => {

 const dispatch = useDispatch();

 const sanctionRemarksColumn = [
   {
     field: "remarkId",
     headerName: "Remarks ID",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "internalapplicationid",
     headerName: "Internal Application ID",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "performerRole",
     headerName: "Performer Role",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "recommendedLoanAmount",
     headerName: "Recommended Loan Amount",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "roi",
     headerName: "ROI",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "tenureInMonths",
     headerName: "Tenure (In Months)",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "emiValue",
     headerName: "EMI Value",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "sanctioned_condition",
     headerName: "Sanctioned Condition",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "createdBy",
     headerName: "Created By",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "modifiedBy",
     headerName: "Modified By",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
   },
   {
     field: "createdDate",
     headerName: "Created Date",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
     valueGetter: (params) => convertDateWithValidation(params.row.createdDate),
   },
   {
     field: "modifiedDate",
     headerName: "Modified Date",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
     valueGetter: (params) =>
       convertDateWithValidation(params.row.modifiedDate),
   },
   {
     field: "remarks",
     headerName: "Remarks",
     headerAlign: "center",
     align: "center",
     flex: 200,
     type: "string",
     editable: false,
     renderCell: (params) => {
       return (
         <Box
           sx={{
             justifyContent: "center",
             display: "flex",
             flex: 25,
           }}
         >
           <Tooltip title="View Remarks">
             <IconButton
               onClick={(e) => {
                 dispatch(
                   CommonInformationDialogReduerAction.updateDialogHeader(
                     "Remarks"
                   )
                 );
                 dispatch(
                   CommonInformationDialogReduerAction.updateDialogText(
                     params.row.remarks
                   )
                 );
                 dispatch(
                   CommonInformationDialogReduerAction.updateDialogOpen(true)
                 );
               }}
             >
               <Visibility sx={{ color: "black" }} />
             </IconButton>
           </Tooltip>
         </Box>
       );
     },
   },
 ];

      return(
        <AccordianContainer
          id="accord"
          title="Sanction Remarks"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={validate(SanctionRemarksInfo) ?
                SanctionRemarksInfo.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []}
            columns={sanctionRemarksColumn}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.remarkId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
      );
}

export default SanctionRemarks;